import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions/repActions';

const defaultState = {
  current: {},
  reps: [],
  count: 0,
  pages: 0,
  activePage: 1,
  query: {
    firmId: '',
    repId: '',
  },
};

const reducer = handleActions(
  {
    [actions.getRepsSuccess]: (state, { payload: { reps, count } }) => {
      return { ...state, reps, count, pages: Math.ceil(count / 20) };
    },
    [actions.setQuery]: (state, { payload: { query } }) => {
      return { ...state, query };
    },
    [combineActions(actions.paginate, actions.setActivePage)]: (state, { payload: { activePage } }) => {
      return { ...state, activePage };
    },
    [combineActions(actions.setCurrentRep, actions.getRepByIdSuccess)]: (state, { payload: { rep } }) => {
      return { ...state, current: rep };
    },
  },
  defaultState
);

export default reducer;
